export const isUnconfiguredConditionNode = (node) => {
  const custom = node?.data?.custom;
  return custom?.key === 'condition' && !(custom?.values?.rules?.length > 0);
};
